import React from 'react'
import { useNavigate } from 'react-router-dom'
import Translate from '../../Components/MultiLanguage/Translate'

const NotFound = () => {
    const navigate = useNavigate()
  return (
    <div className='notFound'>
        <div className="imageContainer">
            <img src={require("../../assets/Images/notFound.png")} alt="" />
        </div>
        <div className="content">
            <h1>404</h1>
            <p><Translate textKey={'page_not_found_message'} /></p>
            <div className="buttonContainer" onClick={()=>navigate("/home")} >
                <div className="background"></div>
                <button><Translate textKey={'back_to_home'}/></button>
            </div>
        </div>
    </div>
  )
}

export default NotFound
